
/**
 * QuickApp应用配置
 */
export const QuickAppConfig = {
  // *** 快应用 ***
  // 爱测评
  '15' : {  
    'type': 'app',
    'name': 'evaluate',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.quick.evaluate',
    'path': '/evaluate/guide/',
  },
  // 肥猫测评
  '16' : {
    'type': 'app',
    'name': 'appraise',
    'domain': 'aiseeking',
    'pkg': 'com.aiseeking.appraise',
    'path': '/appraise/guide/',
  },
  // 肥猫小说
  '18' : {
    'type': 'app',
    'name': 'book',
    'domain': 'uicats',
    'pkg': 'com.uicats.book',
    'path': '/book/guide/',
  },
  // 飞猫小说
  '20' : {
    'type': 'app',
    'name': 'reader',
    'domain': 'uicats',
    'pkg': 'com.uicats.reader',
    'path': '/reader/guide/',
  },
  // 肥猫生活
  '25' : {  
    'type': 'app',
    'name': 'catlife',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.catlife',
    'path': '/launch/catlife/',
  },
  // 爱生活
  '26' : {  
    'type': 'app',
    'name': 'life',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.life',
    'path': '/launch/life/',
  },
  // 白鲸测评
  '27' : {  
    'type': 'app',
    'name': 'elephant',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.elephant',
    'path': '/launch/elephant/',
  },
  // 胖猫测评
  '28' : {  
    'type': 'app',
    'name': 'fatcat',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.fatcat',
    'path': '/launch/fatcat/',
  },
  // 肥猫故事
  '29' : {  
    'type': 'app',
    'name': 'story',
    'domain': 'uicats',
    'pkg': 'com.uicats.story',
    'path': '/launch/story/',
  },
  // 肥猫短剧
  '30' : {  
    'type': 'app',
    'name': 'shortplay',
    'domain': 'uicats',
    'pkg': 'com.uicats.shortplay',
    'path': '/launch/shortplay/',
  },
  // 悠悠测评
  '32' : {  
    'type': 'app',
    'name': 'yycp',
    'domain': 'attll',
    'pkg': 'com.attll.yycp',
    'path': '/launch/yycp/',
  },
  // 天天生活
  '33' : {  
    'type': 'app',
    'name': 'ttsh',
    'domain': 'attll',
    'pkg': 'com.attll.ttsh',
    'path': '/launch/ttsh/',
  },
  // 雪球测评
  '34' : {  
    'type': 'app',
    'name': 'xqcp',
    'domain': 'attll',
    'pkg': 'com.attll.xqcp',
    'path': '/launch/xqcp/',
  },
  // 实时天气
  '35' : {  
    'type': 'app',
    'name': 'sstq',
    'domain': 'attll',
    'pkg': 'com.attll.sstq',
    'path': '/launch/sstq/',
  },
  // 肥猫故事会
  '80' : {  
    'type': 'app',
    'name': 'fmgsh',
    'domain': 'uicats',
    'pkg': 'com.uicats.fmgsh',
    'path': '/launch/fmgsh/',
  },
  // 肥猫日历
  '81' : {  
    'type': 'app',
    'name': 'fmrl',
    'domain': 'uicats',
    'pkg': 'com.uicats.fmrl',
    'path': '/launch/fmrl/',
  },
  // 胖猫计算器
  '85' : {  
    'type': 'app',
    'name': 'pmjsq',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.pmjsq',
    'path': '/launch/pmjsq/',
  },
  // 胖猫壁纸
  '86' : {  
    'type': 'app',
    'name': 'pmbz',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.pmbz',
    'path': '/launch/pmbz/',
  },
  // 胖猫菜谱
  '87' : {  
    'type': 'app',
    'name': 'pmcp',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.pmcp',
    'path': '/launch/pmcp/',
  },
  // 胖猫成语
  '88' : {
    'type': 'app',
    'name': 'pmcy',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.pmcy',
    'path': '/launch/pmcy/',
  },

  // *** 快游戏 ***      
  // 钉钉当当
  '59' : {
    'type': 'game',
    'name': 'dddd',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.dddd',
    'path': '/launch/dddd/',
  },
  // 火力突围
  '60' : {
    'type': 'game',
    'name': 'dddd',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.hltw',
    'path': '/launch/hltw/',
  },
  // 速降求生
  '61' : {
    'type': 'game',
    'name': 'sjqs',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.sjqs',
    'path': '/launch/sjqs/',
  },
  // 消失的水果
  '62' : {
    'type': 'game',
    'name': 'xsdsg',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.xsdsg',
    'path': '/launch/xsdsg/',
  },
  // 管道集结
  '96' : {
    'type': 'game',
    'name': 'gdjj',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.gdjj',
    'path': '/launch/gdjj/',
  },
  // 数字风暴
  '95' : {
    'type': 'game',
    'name': 'szfb',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.szfb',
    'path': '/launch/szfb/',
  },
  // 飞镖王中王
  '97' : {
    'type': 'game',
    'name': 'fbwzw',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.fbwzw',
    'path': '/launch/fbwzw/',
  },
  // 2048 王中王
  '98' : {
    'type': 'game',
    'name': 'elsbwzw',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.elsbwzw',
    'path': '/launch/elsbwzw/',
  },
  // 一触即停
  '93' : {
    'type': 'game',
    'name': 'ycjt',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.ycjt',
    'path': '/launch/ycjt/',
  },
  // 木板搭桥
  '94' : {
    'type': 'game',
    'name': 'mbdq',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.mbdq',
    'path': '/launch/mbdq/',
  },
  // 彩色消除
  '111' : {
    'type': 'game',
    'name': 'csxc',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.csxc',
    'path': '/launch/csxc/',
  },
  // 镜像谜阵
  '112' : {
    'type': 'game',
    'name': 'jjmz',
    'domain': 'ivknow',
    'pkg': 'com.ivknow.game.jjmz',
    'path': '/launch/jjmz/',
  },

  // 镜像谜阵
  '56' : {
    'type': 'game',
    'name': 'gdz',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.gdz',
    'path': '/launch/gdz/',
  },
  // 水果配对
  '57' : {
    'type': 'game',
    'name': 'sgpd',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.sgpd',
    'path': '/launch/sgpd/',
  },
  // 坠落大逃亡
  '58' : {
    'type': 'game',
    'name': 'zldtw',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.zldtw',
    'path': '/launch/zldtw/',
  },
  // 绝境空战
  '66' : {
    'type': 'game',
    'name': 'jjkz',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.jjkz',
    'path': '/launch/jjkz/',
  },
  // 对对碰大作战
  '68' : {
    'type': 'game',
    'name': 'jjkz',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.ddpdzz',
    'path': '/launch/ddpdzz/',
  },
  // 流水拼图
  '67' : {
    'type': 'game',
    'name': 'lspt',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.lspt',
    'path': '/launch/lspt/',
  },
  // 流水拼图
  '69' : {
    'type': 'game',
    'name': 'qstt',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.qstt',
    'path': '/launch/qstt/',
  },
  // 完美定格
  '70' : {
    'type': 'game',
    'name': 'wmdg',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.wmdg',
    'path': '/launch/wmdg/',
  },
  // 色彩大爆炸
  '113' : {
    'type': 'game',
    'name': 'scdbz',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.scdbz',
    'path': '/launch/scdbz/',
  },
  // 反转光域
  '114' : {
    'type': 'game',
    'name': 'fzgy',
    'domain': 'uicats',
    'pkg': 'com.uicats.game.fzgy',
    'path': '/launch/fzgy/',
  },
  // 成语断案
  '55' : {
    'type': 'game',
    'name': 'cyda',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.cyda',
    'path': '/launch/cyda/',
  },
  // 钉钉侠
  '53' : {
    'type': 'game',
    'name': 'ddx',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.ddx',
    'path': '/launch/ddx/',
  },
  // 水果连连乐
  '54' : {
    'type': 'game',
    'name': 'sglll',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.sglll',
    'path': '/launch/sglll/',
  },
  // 铁翼长空
  '65' : {
    'type': 'game',
    'name': 'tyck',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.tyck',
    'path': '/launch/tyck/',
  },
  // 水果变变变
  '71' : {
    'type': 'game',
    'name': 'sgbbb',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.sgbbb',
    'path': '/launch/sgbbb/',
  },
  // 管道迷宫
  '72' : {
    'type': 'game',
    'name': 'gdmg',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.gdmg',
    'path': '/launch/gdmg/',
  },
  // 坠落大逃杀
  '63' : {
    'type': 'game',
    'name': 'zldts',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.zldts',
    'path': '/launch/zldts/',
  },
  // 黄金搭桥手
  '73' : {
    'type': 'game',
    'name': 'hjdqs',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.hjdqs',
    'path': '/launch/hjdqs/',
  },
  // 旋停对决
  '75' : {
    'type': 'game',
    'name': 'xtdj',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.xtdj',
    'path': '/launch/xtdj/',
  },
  // 像素彩虹糖
  '115' : {
    'type': 'game',
    'name': 'xscht',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.xscht',
    'path': '/launch/xscht/',
  },
  // 连锁奇点
  '116' : {
    'type': 'game',
    'name': 'lsjd',
    'domain': 'ivinno',
    'pkg': 'com.ivinno.game.lsjd',
    'path': '/launch/lsjd/',
  },
  // 全民打飞机
  '38' : {
    'type': 'game',
    'name': 'qmdfj',
    'domain': 'attll',
    'pkg': 'com.attll.qmdfj',
    'path': '/launch/qmdfj/',
  },
  // 管道总动员
  '50' : {
    'type': 'game',
    'name': 'gdzdy',
    'domain': 'attll',
    'pkg': 'com.attll.gdzdy',
    'path': '/launch/gdzdy/',
  },
  // 极限坠落
  '51' : {
    'type': 'game',
    'name': 'jxzl',
    'domain': 'attll',
    'pkg': 'com.attll.jxzl',
    'path': '/launch/jxzl/',
  },
  // 球球果力全开
  '76' : {
    'type': 'game',
    'name': 'qqglqk',
    'domain': 'attll',
    'pkg': 'com.attll.qqglqk',
    'path': '/launch/qqglqk/',
  },
  // 清官衙门断案
  '77' : {
    'type': 'game',
    'name': 'qgymda',
    'domain': 'attll',
    'pkg': 'com.attll.qgymda',
    'path': '/launch/qgymda/',
  },
  // 布丁水果彩虹桥
  '78' : {
    'type': 'game',
    'name': 'bdsgch',
    'domain': 'attll',
    'pkg': 'com.attll.bdsgch',
    'path': '/launch/bdsgch/',
  },
  // 转盘猎手
  '89' : {
    'type': 'game',
    'name': 'zpls',
    'domain': 'attll',
    'pkg': 'com.attll.zpls',
    'path': '/launch/zpls/',
  },
  // 极限搭桥
  '90' : {
    'type': 'game',
    'name': 'jxdq',
    'domain': 'attll',
    'pkg': 'com.attll.jxdq',
    'path': '/launch/jxdq/',
  },
  // 飞镖风暴转盘
  '91' : {
    'type': 'game',
    'name': 'fbfbzp',
    'domain': 'attll',
    'pkg': 'com.attll.fbfbzp',
    'path': '/launch/fbfbzp/',
  },
  // 数字突围
  '92' : {
    'type': 'game',
    'name': 'sztw',
    'domain': 'attll',
    'pkg': 'com.attll.sztw',
    'path': '/launch/sztw/',
  },
}
